import { Component, Input, TemplateRef, ContentChild } from '@angular/core';

@Component({
  selector: 'gains-tab',
  standalone: false,
  template: ''
})
export class GainsTabComponent {
  @Input() title!: string; // Title for the tab
  @ContentChild(TemplateRef) template!: TemplateRef<any>; // Template reference for the tab content
  @Input() icon?: string; // Optional icon for the tab
  @Input() tooltipText?: string; // Optional tooltip text for the tab
  @Input() disabled?: boolean; // Optional disabled state for the tab
  @Input() showDot = false; // Optional unsaved-changes indicator dot next to the tab title
}
